import {useEffect, useState} from 'react';

import { useNavigate, redirect } from 'react-router-dom';



import { AuthLayout } from '../catalyst/auth-layout'
import { Button } from '../catalyst/button'
import { ErrorMessage, Field, Label } from '../catalyst/fieldset'
import { Heading } from '../catalyst/heading'
import InputWithError from '../catalyst/custom/inputWithError'
import { Strong, Text, TextLink } from '../catalyst/text'


import LanguageSelector from '../language/LanguageSelector';
import { Trans, useTranslation } from "react-i18next";
import Spinning from '../components/spinning';
import { Logo } from '../logo'
import CheckCircleIcon from '@heroicons/react/24/solid/CheckCircleIcon';

import config from '../config';
import { Link } from 'react-router-dom';
import { set } from 'date-fns';

export default function ForgotPassword() {

    const navigate = useNavigate();

    const [errors, setErrors] = useState({});


    const [errResponse, setErrResponse] = useState("");

    const [formData, setFormData] = useState({
        email: ''
    });

    const { t } = useTranslation(undefined, { keyPrefix: 'forgotPassword' });
    // const {greeting} = t("greeting", {channel: "RoadsideCoder"});

    const [submitting, setSubmitting] = useState(false)


    const [sentSuccessfully, setSentSuccessfully] = useState(false)



    const validate = (submittedFormData) => {
        let errors = {};

        if (!submittedFormData.email) {
            errors.email = t("emailRequired");
        } else if (!/\S+@\S+\.\S+/.test(submittedFormData.email)) {
            errors.email = t("emailInvalid");
        }

        return errors;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        var formDataObj = new FormData(e.currentTarget);
        var newData = {
            email: formDataObj.get('email')
        }
        const validationErrors = validate(newData);
        setFormData(newData)
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {
            setErrors({});
            setSubmitting(true)
            // Handle form submission (e.g., send data to backend)
            fetch(config.apiUrl + "/user/resetPassword", { // Replace with your actual endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(newData)
            })
                .then(response => {
                    setSubmitting(false)
                    if (!response.ok) {
                        if (response.status === 400) {
                            return response.text().then(text => {
                                throw new Error(t(text));
                            });
                        }
                        throw new Error(t("errorSending"));
                    }
                    return response;
                })
                .then(data => {
                    setSubmitting(false)
                    setErrResponse(t("sentMessage"))
                    setSentSuccessfully(true)
                    setErrors({});
                })
                .catch((error) => {
                    setSubmitting(false)
                    setErrResponse(error.message)
                    setErrors({});
                    console.error('Error:', error);
                });
        }

    };

    function ForgotForm() {
        return (
            
        <form onSubmit={handleSubmit} className="grid w-full max-w-sm grid-cols-1 gap-8">
        <div className="flex flex-col items-center justify-center space-y-4">
          <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" redirectHome={true}/>
          <Heading>{t("title")}</Heading>
          <Text>{t("titleNote")}</Text>
        </div>
          <InputWithError error={errors.email} type="email" name="email" label={t("email")} onChange={()=>{}}/>

          <div className="flex items-center justify-between">

            <Text>
                <TextLink href="login">
                <Strong>Back to login?</Strong>
                </TextLink>
            </Text>
            </div>

          {errResponse && <Field><ErrorMessage>{errResponse}</ErrorMessage></Field>}

          <Button type="submit" className="w-full cursor-pointer">
             {submitting ? <Spinning /> :  t("resetPassword")}
          </Button>

          <div className="flex items-center justify-between">
          <Text className="ml-auto">
                {t("dontHaveAnAccount")}
                {' '}
                <TextLink href="signup">
                    <Strong>{t("signup")}</Strong>
                </TextLink>
            </Text>
        </div>
        </form>
        );
    }
    function ResetComfirmation() {
        return (
            <div className="grid w-full max-w-sm grid-cols-1 gap-8">
            <div className="flex flex-col items-center justify-center space-y-4">
            <Logo className="h-6 text-zinc-950 dark:text-white forced-colors:text-[CanvasText]" redirectHome={true}/>
            <Heading>Password Reset email sent</Heading>
            <CheckCircleIcon className="h-30 w-30 text-green-500" aria-hidden="true" />

            <Text>
            We’ve emailed you a link to reset your password to <Strong>{formData.email}</Strong>. 
            </Text>
            <Text>If it hasn’t arrived, check your spam folder or try sending the email again.</Text>
            <Link to={config.loginPath}><Button className="cursor-pointer" onClick={() => {}}>Back to login</Button></Link>
            </div>

            
            </div>
        );
    }
    
    return (

        <AuthLayout>

        {!sentSuccessfully ? (<ForgotForm></ForgotForm>) : (<ResetComfirmation></ResetComfirmation>)}
      </AuthLayout>
    );
}